// fake-api/handlers/apps/customers/index.js
import is from '@sindresorhus/is'
import destr from 'destr'
import { HttpResponse, http } from 'msw'
import { customers } from './db'
import { delay } from '@/utils/datetime'

export const handlerAppsCustomers = [
  // 👉 Get Customers
  http.get('/api/apps/customers', async ({ request }) => {
    const url = new URL(request.url)
    const search = url.searchParams.get('search') || '' // Pobierz parametr wyszukiwania

    await delay(500) // Opcjonalne opóźnienie symulujące czas odpowiedzi API

    // Filtrowanie klientów na podstawie parametru wyszukiwania
    const filteredCustomers = customers.filter((customer) => {
      const term = search.toLowerCase()
      
      return (
        customer.name.toLowerCase().includes(term) ||
        customer.lastname.toLowerCase().includes(term) ||
        (customer.tel && customer.tel.includes(term))
      )
    })

    return HttpResponse.json(filteredCustomers, { status: 200 })
  }),
]
